import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
	async getCCMLabsByPatientId (patientId) {
		const response = await _axios.get(`/ccmlab/getbypatientid/${patientId}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting all CCM Labs by patient ID');
	},

	async getCCMLabsByCCMRecordId (ccmRecordId) {
		const response = await _axios.get(`/ccmlab/getbyccmrecordid/${ccmRecordId}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting all CCM Labs by CCM record ID');
	},

	async getCCMLab (id) {
		const response = await _axios.get(`/ccmlab/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting CCM Lab');
	},

	async addCCMLab (body) {
		const response = await _axios.post('/ccmlab', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error adding CCM Lab');
	},

	async updateCCMLab (id, body) {
		const response = await _axios.put(`/ccmlab/${id}`, body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error updating CCM Lab');
	},

	async deleteCCMLab (id) {
		const response = await _axios.delete(`/ccmlab/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error deleting CCM Lab');
	},

	async uploadLabDocumentToAi (body) {
		const response = await _axios.post('/ccmAttachment/uploadLabDocumentToAi', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting AI Summary for Lab');
	},
};
